import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { InputRules } from "@/rules";
import DatePicker from "@/components/picker/DatePicker.vue";
import PasswordField from "@/components/input/PasswordField.vue";
import CodeMasterSelect from "@/components/input/CodeMasterSelect.vue";
import AffiliationAutocomplete from "@/components/input/AffiliationAutocomplete.vue";
import UserCodeInput from "@/components/input/UserCodeInput.vue";
import AuthoritySelect from "@/components/input/AuthoritySelect.vue";

type Auth = {
  loginId?: string;
  authority?: string;
  password?: string;
  isValid?: string;
};

type Shain1 = {
  incode?: number;
  code?: string;
  name1?: string;
  name2?: string;
  shozoku?: number;
  isValid?: string;
  mnid?: string;
};

type Shain2 = {
  incode?: number;
  furi1?: string;
  furi2?: string;
  sex?: number;
  daybirth?: string;
  daynyu?: string;
  taimode?: number;
  daytai?: string;
  isValid?: string;
};

type Shain3 = {
  incode?: number;
  kkubun?: number;
  kyuhtan12?: number;
};

type ShainExtension = {
  incode?: number;
  dayOver?: string;
  weekWorkStart?: string;
  flexflag?: string;
  qualification?: string;
};

export type UserInfo = Shain1 & Shain2 & Shain3 & Auth & ShainExtension;

type Type = typeof type[number];

type Props = {
  value?: UserInfo;
  type: Type;
};
type Emits = {
  (e: "input", value: UserInfo): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoForm',
  props: {
    value: { default: () => ({}) },
    type: null
  },
  emits: ["input"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "input", value: UserInfo): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: UserInfo, type: Type };

const nameLen = 20;
const passLen = 50;

const type = ["regist", "edit"] as const;



const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const isRegist = computed(() => props.type === "regist");
const isEdit = computed(() => props.type === "edit");

const readonlyHint = computed(() => (isEdit.value ? "編集不可" : ""));

const sex = computed(() =>
  modelValue.value.sex != null ? String(modelValue.value.sex) : ""
);
const taimode = computed(() =>
  modelValue.value.taimode != null ? String(modelValue.value.taimode) : ""
);
const kkubun = computed(() =>
  modelValue.value.kkubun != null ? String(modelValue.value.kkubun) : ""
);

const onCodeChange = (code: string) => {
  const isPasswordEmpty = !modelValue.value.password;
  if (isPasswordEmpty) {
    modelValue.value.password = code;
  }
};

const form = ref();

const validate = (): boolean => form.value?.validate();
const reset = (): void => form.value?.reset();
const resetValidation = (): void => form.value?.resetValidation();

expose({
  validate,
  reset,
  resetValidation
});

return { __sfc: true,nameLen, passLen, type, props, emits, modelValue, isRegist, isEdit, readonlyHint, sex, taimode, kkubun, onCodeChange, form, validate, reset, resetValidation, InputRules, DatePicker, PasswordField, CodeMasterSelect, AffiliationAutocomplete, UserCodeInput, AuthoritySelect }
}

})